import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'select-account',
    loadComponent: () => import('./pages/select-account.page').then(m => m.SelectAccountPage),
  },
  {
    path: 'signin',
    loadComponent: () => import('./pages/signin.page').then(m => m.SigninPage),
  },
  {
    path: 'signup',
    loadComponent: () => import('./pages/signup.page').then(m => m.SignupPage),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy.page').then(m => m.PrivacyPage),
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/terms.page').then(m => m.TermsPage),
  },
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'signin',
  },
];
